import { render, staticRenderFns } from "./PhdModal.vue?vue&type=template&id=0b06ca17&"
import script from "./PhdModal.vue?vue&type=script&lang=js&"
export * from "./PhdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports